module.exports = __webpack_public_path__ + "static/media/swapp.b137aeb1.jpg";